module.exports = __webpack_public_path__ + "static/media/s_pink_2.18d885c8.mp3";